import { PRINT_LOG_SORT } from '../actions/PrintActions';

const INITIAL_STATE = {
  sortModel: [],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case PRINT_LOG_SORT:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
